import { get,post,put } from '@/plugins/http'

export default {
  fetchList: get('/attention/company'),
  searchAppointed: get('/examination/company'),
  appoint: post('/examination/url'),
  removeAppointed: put('/examination'),
}
